// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"302":"swiggy_mxn_render","335":"lottie-web","570":"dine_cash_pooling"}[chunkId] + "." + {"302":"72d73d792836baff166b","335":"f744e625632a60c2dfa4","570":"f4c7c40875057a5890be"}[chunkId] + ".js";
};